export enum NoteShareType {
  meOnly = "MeOnly",
  supplierManagerAndSalesManagerOnly = "SupplierManagerAndSalesManagerOnly",
  everyOne ="EveryOne"
}
